import { useParams } from 'react-router-dom';

export const useCurrentEmployeeId = () => {
  const { current_employee: currentEmployeeId } = useParams();
  return currentEmployeeId;
};
